<template>
    <div :class="['menu-pagination col-revert-item', wrapperClass]">
      <PaginationItemCount :pagination="pagination" />
      <Pagination
        v-if="pagination.total > 10"
        class="flex justify-center pt-2 pb-2"
        :page="pagination.page"
        :totalRecord="pagination.total"
        @onChange="handlePageChange"
      />
      <div class="pagination-right">
        <!-- 上部のページャーのみおすすめ順選択ボックス表示 -->
        <a-select
          v-if="showSort"
          v-model="sortOrder"
          @change="getRecommendPlan"
          class="w-full"
        >
          <a-select-option
            v-for="item in sortRecommend"
            :key="`sort-${item.value}`"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>
  </template>
  
  <script>
  import { Pagination } from '@/components/primitive'
  import { PaginationItemCount } from '@/components/compound'
  
  export default {
    name: 'PaginationWithCount',
    data() {
      return {
        sortRecommend: [
          {
            name: "おすすめ順",
            value: "PROPOSE"
          },
          {
            name: "安い順",
            value: "LOWEST_PRICE"
          },
          {
            name: "高い順",
            value: "HIGHEST_PRICE"
          }
        ],
        sortOrder: "PROPOSE"
      }
    },
    components: { 
      Pagination,
      PaginationItemCount
    },
    props: {
      wrapperClass: {
            type: String,
            default: ""
        },
      items: {
        type: [Object, Array],
        required: true,
      },
      pagination: {
        type: Object,
        required: true,
      },
      showSort: {
        type: Boolean,
        default: false
      }
    },
    computed: {
        pageElementStart() {
            const { page, size, total } = this.pagination
            if (+total === 0) return 0
            return (page - 1) * size + 1
        },
        pageElementEnd() {
            const { total, page, size } = this.pagination
            return total > page * size ? page * size : total
        },
    },    
    methods: {
      handlePageChange(page) {
        this.$emit('paging', page);
      },
      getRecommendPlan(val) {
        this.$emit("sortRecommend", val)
      },
    },    
  };
  </script>
  <style lang="scss" scoped>
  @import './styles.scss';
  </style>